import { DateTime } from 'luxon';

const mostRecentCutoff = (now: DateTime, cutOffHour: number) => {
  const cutOff = now.startOf('day').plus({ hour: cutOffHour });
  return cutOff.valueOf() <= now.valueOf() ? cutOff : cutOff.minus({ day: 1 });
};

const daysSinceLastCutOff = (numDays: number, cutOffHour: number, timezone: string, nowMillis: number): string[] => {
  const now = DateTime.fromMillis(nowMillis).setZone(timezone);
  const mostRecentCutOff = mostRecentCutoff(now, cutOffHour);
  const firstDay = mostRecentCutOff.startOf('day');
  const days = [];
  for (let i = 0; i < numDays; i += 1) {
    days.push(firstDay.plus({ day: i }).toFormat('yyyy-MM-dd'));
  }
  return days;
};

export default daysSinceLastCutOff;
